import { z } from 'zod';

export const deletePatientSchema = z.object({
  patient_id: z.string().min(1),
});

export type DeletePatientPayload = z.infer<typeof deletePatientSchema>;
